<template>
  <b-modal 
    id="fast-report-modal-component" 
    :ref="modalId" 
    @shown="onLoad"
    hide-header
    hide-footer
    class="modal-fast-report"
  >
  <div class="modal-body">
      <b-row>
        <b-col cols="2">
          <b-form-group>
            <template v-slot:label>
              <h6>Select the report to generate and click "Generate" button</h6>
            </template>
            <b-form-checkbox-group
              v-model="selectedReport"
              :options="moduleReports"
              value-field="report"
              text-field="display"
              stacked
            ></b-form-checkbox-group>
          </b-form-group>
          <br/>
          <b-button size="sm" variant="primary" @click="onGenerate" :disabled="selectedReport.length == 0" class="mr-2"> Generate</b-button>
          <!-- <b-button size="sm" variant="primary" @click="onEmail" :disabled="selectedReport.length == 0"> Email</b-button> -->
        </b-col>
        <b-col cols="10">
          <iframe height="700" width="860" :src="generateReport"></iframe>
        </b-col>
      </b-row>
    </div>
  </b-modal>
</template>

<script>
import { REPORTS_CONSTANTS } from '@/shared/constants';

export default {
  props: {
    moduleName: {
      type: String,
      default: null
    },
    parameter: {
      type: [Number, String],
      default: null
    },
    modalId: {
      type: String,
      default: 'view-fast-report'
    },
    iFrameId: {
      type: String,
      default: 'view-report-frame'
    }
  },
  data() {
    return {
      selectedReport: [],
      generateReport: null
    }
  },
  computed: {
    moduleReports() {
      return REPORTS_CONSTANTS.filter(x => x.module == this.moduleName);
    },
  },
  methods: {
    onLoad() {
      this.selectedReport = this.moduleReports.map(x => x.report); 
      console.log(this.selectedReport, this.moduleName)
      this.onGenerate();
    },
    onGenerate() {
      let url = ``;
      let firstRun = true;
      this.generateReport = null;

      for (let i = 0; i < this.selectedReport.length; i++) {
        url += `reports=${this.selectedReport[i]}&`;
      }

      url += `paramValue=${this.parameter}`;

      this.generateReport = (this.selectedReport.length > 0) ? process.env.VUE_APP_API_URL + 'DisplayReport?' + url : null;
    },
    onEmail() {
      this.$emit('onEmail', this.selectedReport);
    },
    showModal() {
      this.$refs[this.modalId].show();
    }
  }
}
</script>

<style>
#fast-report-modal-component .modal-dialog {
  max-width: 1110px !important;
}

</style>